import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  HomeFunIcon,
  NewSettingsIcon,
  UsersIcon,
  WebpageLoadingIcon,
  SearchIconComponent,
  CloseOutlineIconComponent,
} from "../../../assets/icons";
import { setAgentOnline } from "redux/chats/chats.actions";
import { DEFAULT_AVATAR_URL } from "../../../utils/constants";
import Switch from "./components/Switch";
import { useNavigate } from "react-router-dom";
import routes from "routes";
import useMediaQuery from "use-mediaquery";
import useTranslation from "hooks/useTranslation";
import styles from "./styles.module.scss";

const getAgent = ({ userData }) => userData.agent.data;
const getOnlineUsersCount = ({ generalData }) => generalData.onlineUsersBadge;
const getAgentLoading = ({ userData }) => userData.agent.loading;

const UserListHeader = ({
  setSearchingMessage,
  searchingMessage,
  setConvBodyContent,
  toggleSettings,
}) => {
  const agent = useSelector(getAgent);
  const onlineUsersCount = useSelector(getOnlineUsersCount);
  const onlineUsersBadgeCount = onlineUsersCount > 0 ? onlineUsersCount : 0;
  const agentLoading = useSelector(getAgentLoading);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSmallDevice = useMediaQuery("(max-width: 600px)");
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const [isSearching, setIsSearching] = useState(false);

  const agentFullName = agent && `${agent.name} ${agent.lname}`;

  const renderAgentInfoSkeleton = (
    <div className="conv__list__header__title w-100">
      <span style={{ paddingRight: "8px" }} className="flex flex-ai-c w-100">
        <div className="conv__userinfo__card__info__header flex flex-ai-c w-100">
          <div className="conv__userinfo__card__info__header__img flex-noflex skeleton"></div>
          <div className="conv__userinfo__card__info__header__text">
            <div className="conv__userinfo__card__info__header__text__title">
              <p className="flex skeleton-text  skeleton"></p>
              <p className="flex skeleton-text  skeleton"></p>
            </div>
          </div>
        </div>
      </span>
    </div>
  );

  return (
    <div className={styles.heading_box}>
      {agentLoading ? (
        renderAgentInfoSkeleton
      ) : (
        <div className={styles.showcase}>
          <div className={styles.showcase__profile}>
            <div className={styles.showcase__profile__avatar}>
              <img
                src={agent.avatar}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = DEFAULT_AVATAR_URL;
                }}
                alt=""
              />
            </div>
            <div className={styles.showcase__profile__operator}>
              <div
                dir="auto"
                className={styles.showcase__profile__operator__name}
              >
                <span title={agentFullName}> {agentFullName} </span>
              </div>
              <div className={styles.showcase__profile__operator__status}>
                <span
                  className={styles.showcase__profile__operator__status__text}
                >
                  {agent.online ? t("ONLINE") : t("OFFLINE")}
                </span>
                <div className="conv__userinfo__card__info__header__switch flex">
                  <Switch
                    checked={!!agent.online}
                    onChecked={() => dispatch(setAgentOnline(!agent.online))}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.showcase__toolbar}>
            <div
              data-tool-tip-top={t("HOME")}
              onClick={() => {
                setConvBodyContent("userChannels");
                navigate(routes.home);
              }}
              className={styles.showcase__toolbar__home}
            >
              <img src={HomeFunIcon} alt="home" />
            </div>
            <div
              data-tool-tip-top={t("AGENTS")}
              onClick={() => {
                window.history.pushState(null, "", window.location.href);
                setConvBodyContent("partners");
                navigate(routes.agents);
              }}
              className={styles.showcase__toolbar__operators}
            >
              <img src={UsersIcon} alt="operators" />
            </div>
            <div
              data-tool-tip-top={isSmallDevice ? undefined : t("SETTINGS")}
              onClick={() => toggleSettings()}
              className={styles.showcase__toolbar__settings}
            >
              <img src={NewSettingsIcon} alt="settings" />
            </div>
          </div>
        </div>
      )}

      <div data-is-searching={isSearching} className={styles.tools}>
        <div className={styles.tools__search}>
          <div className={styles.tools__search__icon}>
            <SearchIconComponent />
          </div>
          <div className={styles.tools__search__input}>
            <input
              onFocus={() => setIsSearching(true)}
              placeholder={t("SEARCH_IN_CONVS")}
              value={searchingMessage}
              onChange={(e) => setSearchingMessage(e.target.value)}
            />

            <div
              onClick={() => {
                setSearchingMessage("");
                setIsSearching(false);
              }}
              data-show={isSearching}
              className={styles.close_icon}
            >
              <CloseOutlineIconComponent />
            </div>
          </div>
        </div>
        <div
          onClick={() => {
            setConvBodyContent("onlineUsers");
            navigate(routes.users);
          }}
          className={styles.tools__online_users}
        >
          <WebpageLoadingIcon />
          <span className={styles.tools__online_users__text}>
            {" "}
            {t("ONLINE_USERS")}{" "}
          </span>

          <div title={onlineUsersBadgeCount} className={styles.count}>
            {onlineUsersBadgeCount}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserListHeader;
